/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { GateResponseDto } from '../model'
/**
 * GatesApi - axios parameter creator
 */
export const GatesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {boolean} [includeActive]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      includeActive?: boolean,
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/Gates`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (includeActive !== undefined) {
        localVarQueryParameter['IncludeActive'] = includeActive
      }

      if (includeInactive !== undefined) {
        localVarQueryParameter['IncludeInactive'] = includeInactive
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/Gates/active`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GatesApi - functional programming interface
 */
export const GatesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GatesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {boolean} [includeActive]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      includeActive?: boolean,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GateResponseDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        includeActive,
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GatesApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActive(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GateResponseDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActive(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GatesApi.getActive']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GatesApi - factory interface
 */
export const GatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GatesApiFp(configuration)
  return {
    /**
     *
     * @param {boolean} [includeActive]
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      includeActive?: boolean,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GateResponseDto>> {
      return localVarFp
        .get(includeActive, includeInactive, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActive(options?: RawAxiosRequestConfig): AxiosPromise<Array<GateResponseDto>> {
      return localVarFp.getActive(options).then(request => request(axios, basePath))
    },
  }
}

/**
 * GatesApi - object-oriented interface
 */
export class GatesApi extends BaseAPI {
  /**
   *
   * @param {boolean} [includeActive]
   * @param {boolean} [includeInactive]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(includeActive?: boolean, includeInactive?: boolean, options?: RawAxiosRequestConfig) {
    return GatesApiFp(this.configuration)
      .get(includeActive, includeInactive, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getActive(options?: RawAxiosRequestConfig) {
    return GatesApiFp(this.configuration)
      .getActive(options)
      .then(request => request(this.axios, this.basePath))
  }
}
